// Payment System v3.0 PR 11 — shared formatting + CSV-export helpers for
// the four ledger views (design spec §10.7).

export function formatMoney(amount: number | null | undefined): string {
  if (amount === null || amount === undefined) return "—";
  return amount.toLocaleString(undefined, {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatPct(pct: number | null | undefined): string {
  if (pct === null || pct === undefined) return "—";
  return `${pct.toLocaleString(undefined, { maximumFractionDigits: 4 })}%`;
}

import { FALLBACK_TIMEZONE, formatDateInTz, formatDateTimeInTz } from "@/utils/datetime";

export function formatDate(iso: string | null | undefined, tz: string = FALLBACK_TIMEZONE): string {
  if (!iso) return "—";
  return formatDateInTz(iso, tz) || "—";
}

export function formatDateTime(iso: string | null | undefined, tz: string = FALLBACK_TIMEZONE): string {
  if (!iso) return "—";
  return formatDateTimeInTz(iso, tz) || "—";
}

/**
 * Quote a single CSV cell. Encloses values containing commas, quotes, or
 * newlines in double quotes and doubles any embedded quotes (RFC 4180).
 */
function csvQuote(value: unknown): string {
  if (value === null || value === undefined) return "";
  const s = String(value);
  if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

export function downloadCsv(
  fileName: string,
  headers: string[],
  rows: (string | number | null | undefined)[][],
) {
  const lines = [
    headers.map(csvQuote).join(","),
    ...rows.map((r) => r.map(csvQuote).join(",")),
  ];
  const blob = new Blob([lines.join("\n")], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
